'use strict';

import template from './template/notification-chat.html';
import { getActiveBoardLngs } from '../../store/model/selectors/getActiveBoardLngs';
import { getAppState } from '../../store/configureStore';
import { getInitialsHelper } from "../react_components/helpers/getInitialsHelper";
import { blockMarkdown, markdown } from "../../helper/markdownHelper";
import { escape } from "underscore";
import { getCommentDate } from "../react_components/main/chatView/chats/components/Chat/helpers/getCommentDate";
import { root } from "../../store/constants";
import { renderToStaticMarkup } from "react-dom/server";
import ReactHtmlParser from "react-html-parser";
import { getAuthUser } from "../../store/model/authUser/selectors/getAuthUser";

App.Views.ChatNotification = Backbone.View.extend({
    className: 'notifire notifire--chat',

    initialize: function() {
        var lngs = getActiveBoardLngs(getAppState());
        this.template = App.MLTemplate.getTemplate('#notification-chat', lngs, template);
        this.listenTo(this, 'click', this.onClick);
    },

    /**
     * Настройки NOTY
     * @returns {{timeout: number}}
     */
    getSettings: function() {
        return {
            timeout: 10 * App.Util.TIME.SECOND * 1000
        };
    },

    render: function() {
        const {
            cardName,
            cardNumber,
            lastCommentInfo,
        } = this.model;
        this.$el.html(this.template({
            cardInitials: getInitialsHelper(markdown(escape(cardName))).toUpperCase(),
            cardName: renderToStaticMarkup(ReactHtmlParser(blockMarkdown(cardName))),
            date: getCommentDate(lastCommentInfo.commentTime * 1000),
            cardNumber,
            user: lastCommentInfo.userName + (lastCommentInfo?.mentions?.includes(getAuthUser(getAppState()).permissionId) ? Messages.getText('noty.chat.mention') : ''),
            isAttachments: lastCommentInfo.hasDriveDocs,
            text: renderToStaticMarkup(ReactHtmlParser(blockMarkdown(lastCommentInfo.text))),
        }));
        this.$el.attr('data-cid', this.cid);
        return this;
    },

    onClick: function(e) {
        const { chatGroupId, id } = this.model;
        root.App.router.navigate(root.App.router.getChatsViewUrl(chatGroupId, id), { trigger: true });
        e.stopPropagation();
    }
});
